export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Calls `check` until it returns something other than null or undefined, up to `attempts` times
 * with `intervalMs` between calls. Returns null if it never does. Errors from `check` propagate.
 */
export async function pollUntil<T>(
  check: () => Promise<T | null | undefined>,
  { attempts, intervalMs }: { attempts: number; intervalMs: number },
): Promise<T | null> {
  for (let attempt = 1; attempt <= attempts; attempt++) {
    const result = await check();
    if (result !== null && result !== undefined) return result;
    if (attempt < attempts) await sleep(intervalMs);
  }
  return null;
}
